var map = {
	"./1.svg": 31579,
	"./2.svg": 80840,
	"./3.svg": 46233,
	"./4.svg": 89846,
	"./5.svg": 70023,
	"./6.svg": 5460,
	"./7.svg": 78069,
	"./8.svg": 23954,
	"./9.svg": 38595
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31322;